module.exports = __webpack_public_path__ + "static/media/bgShare3@3x.b5684f8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/wechatShare/components/images/bgShare3@3x.png
// module id = 889
// module chunks = 0